import errorsSchema from './error/errorsSchema';

export const label = (field: string) =>
  errorsSchema[field] && errorsSchema[field].presence
    ? errorsSchema[field].presence.label
    : field;
